var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8683 16.2807V16.292M11.8683 12.9029C12.3747 12.9044 12.8668 12.7352 13.2652 12.4226C13.6636 12.11 13.945 11.6723 14.064 11.18C14.1829 10.6878 14.1325 10.1699 13.9208 9.70981C13.7092 9.24977 13.3486 8.8745 12.8974 8.6446C12.4495 8.41515 11.9371 8.344 11.4436 8.44274C10.9501 8.54148 10.5046 8.8043 10.1794 9.18843M9.61643 21.6594C8.63671 21.4361 7.69563 21.0684 6.8241 20.5683",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1202 1.89453C16.3587 2.40579 18.3574 3.66191 19.7889 5.45724C21.2204 7.25257 22 9.48073 22 11.7769C22 14.0731 21.2204 16.3013 19.7889 18.0966C18.3574 19.8919 16.3587 21.148 14.1202 21.6593M3.5127 17.5113C2.89916 16.6186 2.43273 15.6333 2.13117 14.5929M1.87445 10.088C2.0546 9.01836 2.40139 8.00501 2.8878 7.07611L3.07808 6.7327M6.13389 3.42131C7.18799 2.69719 8.36964 2.17915 9.61642 1.89453",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingMenu);
export default __webpack_public_path__ + "static/media/parkingMenu.f1597b0225b4f44c69b34e6e7e662c50.svg";
export { ForwardRef as ReactComponent };